module.exports = __webpack_public_path__ + "images/CC_Sortation_Placeholder.png";